import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import siteConfig from '@app/site-config';
import { Utilities } from '@shared/utils/utilities';

@Pipe({
  name: 'countryCodeTranslate',
  standalone: true
})
export class CountryCodeTranslate implements PipeTransform {
  translateService = inject(TranslateService);

  constructor() { }
  transform(value: string): string {
    if (Utilities.isEmptyString(value)) {
      return "";
    }

    return this.translateService.instant(siteConfig.CountryCodeMapping[value]);
  }
}
